/// <reference path="../_references.ts"/>

module App.Administrative.Inventory {
	angular
		.module('administrative.inventory', [])
		.config(['$stateProvider', ($stateProvider: ng.ui.IStateProvider) => {
			$stateProvider
				.state('zipSolutions.old.inventorySummary', {
					url: 'inventory-summary',
					redirectTo: 'zipSolutions.administrative.inventory',
				})
				.state('zipSolutions.old.inventorySelect', {
					url: 'inventory-select',
					redirectTo: 'zipSolutions.administrative.inventory.select',
				})
				.state('zipSolutions.administrative.inventory', {
					url: '/inventory?standalone',
					data: {
						title: 'Inventory Summary'
					},
					params: {
						standalone: {
							dynamic: true,
							type: 'string',
							value: '',
							squash: true,
						},
					},
					views: {
						'content@': {
							controller: 'InventorySummaryController',
							controllerAs: 'ctrl',
							templateUrl: 'html/administrative/inventory/inventory-summary.html',
						},
					},
				})
				.state('zipSolutions.administrative.inventory.select', {
					url: '/select',
					data: {
						title: 'Inventory Select'
					},
					params: {
						selectedWarehouse: null
					},
					views: {
						'content@': {
							controller: 'InventorySelectController',
							controllerAs: 'ctrl',
							templateUrl: 'html/administrative/inventory/inventory-select.html',
						},
					},
				});
		}])
		.service('InventoryService', InventoryService.Factory())
		.controller('InventorySummaryController', InventorySummaryController)
		.controller('InventorySelectController', InventorySelectController);
}